// extracted by mini-css-extract-plugin
export default {"actionButton":"TeamsTableMenu_actionButton__e59ob"};